// modules/teamCarBanner.js
const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;

if (ScrollTrigger) {
    try {
        gsap.registerPlugin(ScrollTrigger);
    } catch (e) {}
}

export default function initTeamCarBanner(){
    const root = document.querySelector(".team-car-banner");
    if (!root) return () => {};
    const prefersReduced = (
        document.documentElement.dataset.ignorePrm === '1'
    ) ? false : window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const frame = root.querySelector(".car-frame");
    const logo  = root.querySelector(".car-logo");
    const img   = root.querySelector(".car-img");

    const triggers = [], tweens = [];
    const track = t => { if (t?.vars?.scrollTrigger) triggers.push(t.vars.scrollTrigger); tweens.push(t); return t; };

    if (!prefersReduced && logo){
        track(gsap.from(logo, {
            autoAlpha: 0, y: -12, duration: .55, ease: "power2.out",
            scrollTrigger: { trigger: frame, start: "top 82%", toggleActions: "play none none reverse" }
        }));
    }

    if (!prefersReduced && img && frame){
        // поява кадру: мʼякий fade + невеликий scale-in (Ken Burns)
        track(gsap.fromTo(img, { autoAlpha:0, scale:1.04 }, {
            autoAlpha:1, scale:1, duration:.8, ease:"power2.out",
            scrollTrigger: { trigger: frame, start:"top 88%", toggleActions:"play none none reverse" }
        }));

        // паралакс по скролу
        const amp = Math.min(18, Math.max(8, Math.round(window.innerHeight / 80)));
        track(gsap.to(img, {
            y: amp, ease:"none",
            scrollTrigger: { trigger: frame, start:"top bottom", end:"bottom top", scrub:.4 }
        }));
    }

    return () => { triggers.forEach(t=>t?.kill()); tweens.forEach(t=>t?.kill()); };
}
